type RouteType =
  | 'home'
  | 'login'
  | 'check_your_email'
  | 'unauthorized'
  | 'error_404'
  | 'super_admin_dashboard'
  | 'super_admin_dashboard_organizations'
  | 'super_admin_dashboard_single_organization'
  | 'super_admin_dashboard_users'
  | 'super_admin_dashboard_tellets'
  | 'super_admin_dashboard_prompts';

const Routes: Record<RouteType, { path: string }> = {
  home: {
    path: '/',
  },
  error_404: {
    path: '/404',
  },

  login: {
    path: '/login',
  },
  check_your_email: {
    path: '/check-your-email',
  },
  unauthorized: {
    path: '/unauthrorized',
  },

  // -- SUPER ADMIN --
  super_admin_dashboard: {
    path: '/admin/dashboard',
  },
  super_admin_dashboard_organizations: {
    path: '/admin/dashboard/organizations',
  },
  // +id
  super_admin_dashboard_single_organization: {
    path: '/admin/dashboard/organizations',
  },
  super_admin_dashboard_users: {
    path: '/admin/dashboard/users',
  },
  super_admin_dashboard_tellets: {
    path: '/admin/dashboard/tellets',
  },
  super_admin_dashboard_prompts: {
    path: '/admin/dashboard/prompts',
  },
};

export default Routes;
